import { render } from "./TextUs.vue?vue&type=template&id=92a0d090&scoped=true"
import script from "./TextUs.vue?vue&type=script&lang=js"
export * from "./TextUs.vue?vue&type=script&lang=js"

import "./TextUs.vue?vue&type=style&index=0&id=92a0d090&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92a0d090"]])

export default __exports__